import Axios from '../config/Axios';

export default function loadTreeView(nParentId = null) {
  return Axios.get('/folder/tree', {
    params: nParentId ? { nParentId } : {}
  }).then(response => response.data);
}

